const defaults = {
  fromBoardUid: '',
  tabsData: [],
  cacheValid: false, // 判断是否进入了kpi设置页面用以清除缓存数据
}

const filter = {
  namespaced: true,
  state: Object.assign({}, defaults),
  mutations: {
    setFromBoardUid(state, uid) {
      state.fromBoardUid = uid
    },
    setTabsData(state, val) {
      state.tabsData = val
    },
    setCacheValid(state, val) {
      state.cacheValid = val
    },
  },
  actions: {
    setFromBoardUid({ commit }, uid) {
      commit('setFromBoardUid', uid)
    },
    setTabsData({ commit }, val) {
      commit('setTabsData', val)
    },
  },
}

export default filter
